// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2936":"d957c3bc","4239":"7aa371cc","9195":"7aa371cc","9435":"ee210f5b"}[chunkId] + ".chunk.css";
};